export default "__VITE_ASSET__CaTwSIBo__"